<template>
  <v-layout column style="overflow-x: hidden !important">
    <vue-snotify></vue-snotify>
    <v-sheet class=" mt-0 mb-4">
      <v-card flat>
        <v-row class="pa-6">
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="8"
            :class="{
              'pa-1': $vuetify.breakpoint.xsOnly,
              'pa-4': $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-row>
              <v-avatar class="ma-2" color="primary" size="60">
                <v-icon color="white" style="font-size: 30px;"
                  >icons8-male-user</v-icon
                >
              </v-avatar>
              <v-card-title
                :class="{
                  title: $vuetify.breakpoint.xsOnly,
                }"
                >Welcome, {{ userProfile.fullName }}
              </v-card-title>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="4"
            :class="{
              'py-1 ml-4': $vuetify.breakpoint.xsOnly,
              'pt-9 pr-2': $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-layout row justify-end>
              <v-card-actions>
                <v-btn color="secondary" class="white--text" v-on:click="logout()">
                  Logout
                </v-btn>
              </v-card-actions>
            </v-layout>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-text class="pb-6 mb-6">
          <div class="title text--primary" style="text-align: left">
            Account details
          </div>
          
        </v-card-text>
        <v-layout align-center justify-center>
          <v-list flat width="90%" color="cardBackground">
            <v-list-item-group color="primary">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="toolForeground" style="font-size: 45px;"
                        >icons8-name-tag</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-content style="text-align: left">
                      <v-list-item-title
                        >Name
                        <v-icon
                          @click="editName = !editName"
                          v-if="editName === false"
                          class="ml-4"
                          color="primary"
                          >icons8-edit</v-icon
                        ></v-list-item-title
                      >
                      <v-list-item-subtitle v-if="editName === false">{{
                        userProfile.fullName
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="editName === true">
                        <v-text-field
                          v-model="userProfile.fullName"
                        ></v-text-field>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-row
                    v-if="editName === true"
                    align="end"
                    justify="end"
                    class="mb-4 ml-2 mt-1"
                  >
                    <v-btn
                      color="inputBackground"
                      class="mr-1 error--text"
                      @click="editName = !editName"
                      ><v-icon size="13" left>icons8-multiply-3</v-icon>Cancel</v-btn
                    >

                    <v-btn
                      color="inputBackground"
                      class="mr-3 px-7 success--text"
                      @click="saveName"
                      ><v-icon small left> icons8-save-2</v-icon>Save</v-btn
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon
                        color="toolForeground"
                        class="mt-2"
                        style="font-size: 40px;"
                        >icons8-envelope</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-content class="mt-2" style="text-align: left">
                      <v-list-item-title
                        >Email address
                        <v-icon
                          @click="editEmail = !editEmail"
                          v-if="editEmail === false"
                          class="ml-4"
                          color="primary"
                          >icons8-edit</v-icon
                        ></v-list-item-title
                      >
                      <v-list-item-subtitle v-if="editEmail === false">{{
                        userProfile.email
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="editEmail === true">
                        <v-text-field
                          v-model="userProfile.email"
                        ></v-text-field>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-row
                    v-if="editEmail === true"
                    align="end"
                    justify="end"
                    class="mb-4 ml-2 mt-1"
                  >
                    <v-btn
                      color="inputBackground"
                      class="mr-1 error--text"
                      @click="editEmail = !editEmail"
                      ><v-icon size="13" left>icons8-multiply-3</v-icon>Cancel</v-btn
                    >

                    <v-btn
                      color="inputBackground"
                      class="mr-3 px-7 success--text"
                      @click="saveEmail"
                      ><v-icon small left> icons8-save-2</v-icon>Save</v-btn
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon
                        color="toolForeground"
                        class="mt-2"
                        style="font-size: 45px;"
                        >icons8-group-task</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-content class="mt-3" style="text-align: left">
                      <v-list-item-title>User level</v-list-item-title>
                      <v-list-item-subtitle>{{
                        userLevelName
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-group>
          </v-list>
        </v-layout>
      </v-card>
    </v-sheet>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";

export default {
  name: "UserProfile",
  components: {},
  data() {
    return {
      userProfile: {},
      showUpdateOption: false,
      editEmail: false,
      editName: false,
    };
  },
  computed: {
    ...mapGetters({
      currUser: "currUser",
    }),
    userLevelName: function() {
      var levelName = "";
      switch (this.userProfile.userTypeId) {
        case "100":
          levelName = "Admin";
          break;
        case "10":
          levelName = "Standard";
          break;
      }
      return levelName;
    },
  },
 
 
  methods: {
    async readUserProfile() {
      //const currentUserID = this.$firebase.auth.currentUser.uid;
      const currentUserEmail = this.currUser.email;
      // console.log("currUser ID: " + currentUserEmail);
      var t = this;
      var docID = 0;
      await this.$firebase.db
        .collection("users")
        .where("email", "==", currentUserEmail)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            docID = doc.id;
            //console.log("user profile:  " + JSON.stringify(doc.data(), null,2));
            t.userProfile = doc.data();
          });
        });
      // console.log("user profile:  " + JSON.stringify(this.userProfile, null,2));
      if (parseInt(this.userProfile.userTypeId) > 10) {
        this.showUpdateOption = true;
      }
    },
    logout() {
      this.$firebase.auth.signOut().then(() => {
        this.$router.push("/").catch((err) => {});
      });
    },
    saveName() {
      var user = this.$firebase.auth.currentUser;
      //  console.log(JSON.stringify(user, null, 2))
      var t = this;

      user
        .updateProfile({
          displayName: t.userProfile.fullName,
        })
        .then(function() {
          // Update successful.
          t.$firebase.db
          .collection("users")
          .doc(t.currUser.id)
          .set(t.userProfile)
          .then((docRef) => {
              t.$snotify.success("The name was updated.");
          })
          .catch((error) => {
           // console.log("Error adding document: ", error);
            t.$snotify.error(error);
          });
        
        })
        .catch(function(error) {
          // An error happened.
          t.$snotify.error(error);
        });
      this.saveName = true;
    },
    saveEmail() {
      var user = this.$firebase.auth.currentUser;
      //  console.log(JSON.stringify(user, null, 2))
      var t = this;
      user
        .updateEmail(t.userProfile.email)
        .then(function() {
          t.$firebase.db
          .collection("users")
          .doc(t.userProfile.id)
          .set(t.userProfile)
          .then((docRef) => {
              t.$snotify.success("The email was updated.");
          })
          .catch((error) => {
          //  console.log("Error adding document: ", error);
            t.$snotify.error(error);
          });
        })
        .catch(function(error) {
          // An error happened.
        //  console.log(error);
          t.$snotify.error("An error occured.");
        });
      this.saveEmail = false;
    },
  },
  mounted() {
    this.readUserProfile();
  },
};
</script>

<style></style>
